import { render, staticRenderFns } from "./StandardBankForm.vue?vue&type=template&id=783e5440"
import script from "./StandardBankForm.vue?vue&type=script&lang=js"
export * from "./StandardBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports